export type RabbitMQAction = 'none' | 'requeue' | 'requeue-if-needed' | 'delete';

/**
 * Routing keys des files pour lesquelles l'action "Rejouer si besoin" a un sens : celles
 * dont le consumer alimente une table portant une date de dernière mise à jour
 * (CommandeGestion, BonLivraisonGestion, FactureGestion), ce qui permet au backend de
 * détecter qu'un message plus récent a déjà corrigé la pièce.
 */
export const REQUEUE_IF_NEEDED_ROUTING_KEYS = [
  'GESCOM_UPDATE_PIECE_COMMANDE_TO_PAV',
  'GESCOM_UPDATE_PIECE_VENTE_TO_PAV',
  'GESCOM_UPDATE_PIECE_LIVRAISON_TO_PAV',
  'GESCOM_UPDATE_PIECE_FACTURE_TO_PAV',
];

/** Indique si l'action "Rejouer si besoin" est proposée pour une routing key donnée. */
export const supportsRequeueIfNeeded = (routingKey: string): boolean =>
  REQUEUE_IF_NEEDED_ROUTING_KEYS.some((key) => (routingKey || '').includes(key));

export type RabbitMQErrorMessage = {
  id: string;
  exchange: string;
  routingKey: string;
  queue: string;
  message: string;
  exceptionMessage: string;
  exceptionStackTrace: string;
  dateTime: Date;
  action: RabbitMQAction;
};

export type GroupedErrorMessages = {
  routingKey: string;
  count: number;
  messages: RabbitMQErrorMessage[];
};

export type ApplyActionsResult = {
  requeued: number;
  deleted: number;
  kept: number;
  skippedUpToDate: number;
  /** Non rejoués car un message plus récent de la même pièce a été rejoué à leur place. */
  skippedSupersededByNewer: number;
};

export type RabbitMQManagerState = {
  isLoading: boolean;
  errorMessages: GroupedErrorMessages[];
  error: string | null;
};
